(function () {
  'use strict';

  var RELEVANCE_WEIGHT_DEFAULT = 4;
  var SORT_STAGGER_MS = 55;

  function buildDistributionRow(starLevel, starCount, total) {
    var pct = total > 0 ? Math.round((starCount * 100) / total) : 0;
    return (
      '<div class="review-summary__bar-row">' +
      '<span class="review-summary__bar-label">' +
      starLevel +
      '<span class="review-summary__bar-star" aria-hidden="true">★</span>' +
      '</span>' +
      '<div class="review-summary__bar-track" role="presentation">' +
      '<span class="review-summary__bar-fill" style="width:' +
      pct +
      '%;"></span>' +
      '</div>' +
      '<span class="review-summary__bar-count">' +
      starCount +
      '</span>' +
      '</div>'
    );
  }

  function readDistributionFromJson() {
    var jsonEl = document.getElementById('ProductReviewDistribution');
    if (!jsonEl) return null;

    try {
      var data = JSON.parse(jsonEl.textContent);
      if (!data || !data.stars || data.stars.length < 5) return null;
      var count = parseInt(data.count, 10) || 0;
      if (count < 1) {
        count = data.stars.reduce(function (sum, n) {
          return sum + (parseInt(n, 10) || 0);
        }, 0);
      }
      if (count < 1) return null;
      return { stars: data.stars, count: count };
    } catch (e) {
      return null;
    }
  }

  function readDistributionFromReviewsList() {
    var list = document.querySelector('[data-reviews-list]');
    if (!list) return null;

    var stars = [0, 0, 0, 0, 0];
    var items = list.querySelectorAll('[data-review-rating]');
    items.forEach(function (item) {
      var rating = parseInt(item.getAttribute('data-review-rating'), 10);
      if (rating >= 1 && rating <= 5) {
        stars[rating - 1] += 1;
      }
    });

    var count = stars.reduce(function (sum, n) {
      return sum + n;
    }, 0);

    if (count === 0) return null;
    return { stars: stars, count: count };
  }

  function readDistributionFromSummaryAttr(summary) {
    var raw =
      summary.getAttribute('data-review-summary-distribution') ||
      summary.getAttribute('data-distribution-counts');
    if (!raw) return null;

    var parts = raw.split(',');
    if (parts.length < 5) return null;

    var stars = parts.slice(0, 5).map(function (part) {
      return parseInt(part, 10) || 0;
    });
    var count = stars.reduce(function (sum, n) {
      return sum + n;
    }, 0);

    if (count === 0) return null;
    return { stars: stars, count: count };
  }

  function paintReviewDistribution() {
    var summary =
      document.querySelector('.product-reviews__summary') ||
      document.querySelector('.product-reviews__summary-grid');
    var mount =
      document.querySelector('[data-review-distribution]') ||
      document.querySelector('.review-summary__distribution');
    if (!summary || !mount) return;

    var data =
      readDistributionFromReviewsList() ||
      readDistributionFromJson() ||
      readDistributionFromSummaryAttr(summary);

    if (!data || data.count < 1) return;

    var html = '';
    for (var level = 5; level >= 1; level--) {
      html += buildDistributionRow(level, data.stars[level - 1] || 0, data.count);
    }

    mount.innerHTML = html;
    summary.classList.add('product-reviews__summary--has-distribution');
    summary.classList.add('product-reviews__summary-grid--has-distribution');

    var barsWrap =
      mount.closest('.product-reviews__summary-bars') ||
      mount.closest('.product-reviews__summary-col--bars');
    if (barsWrap) barsWrap.hidden = false;
  }

  paintReviewDistribution();

  function initReviewRatingInputs() {
    document.querySelectorAll('[data-review-rating-input]').forEach(function (ratingFieldset) {
      var starLabels = ratingFieldset.querySelectorAll('.product-reviews__star-label');

      function paintStars(upTo) {
        starLabels.forEach(function (label) {
          var val = parseInt(label.getAttribute('data-star-value'), 10);
          var star = label.querySelector('.product-reviews__star');
          if (star) star.classList.toggle('is-filled', val <= upTo);
        });
      }

      function syncFromChecked() {
        var checked = ratingFieldset.querySelector('input[name="review_rating"]:checked');
        paintStars(checked ? parseInt(checked.value, 10) : 0);
      }

      ratingFieldset.addEventListener('change', syncFromChecked);

      starLabels.forEach(function (label) {
        label.addEventListener('mouseenter', function () {
          paintStars(parseInt(label.getAttribute('data-star-value'), 10));
        });
      });

      ratingFieldset.addEventListener('mouseleave', syncFromChecked);
      syncFromChecked();
    });
  }

  initReviewRatingInputs();

  function initReviewForms() {
    document.querySelectorAll('.product-reviews__form').forEach(function (reviewForm) {
      reviewForm.addEventListener('submit', function () {
        var bodyField = reviewForm.querySelector('[data-review-body-field]');
        var messageField = reviewForm.querySelector('[data-review-message]');
        var rating = reviewForm.querySelector('input[name="review_rating"]:checked');
        var productField = reviewForm.querySelector('input[name="contact[product]"]');
        if (!bodyField || !messageField) return;

        var lines = [
          '--- Product review (pending approval) ---',
          'Product: ' + (productField ? productField.value : ''),
          'Rating: ' + (rating ? rating.value + '/5' : ''),
          '---',
          messageField.value,
        ];

        var photoNote = reviewForm.querySelector('[data-review-photo]');
        if (photoNote && photoNote.files && photoNote.files[0]) {
          lines.push('', 'Note: Customer attached a review photo. Add manually when approving.');
        }

        var avatarNote = reviewForm.querySelector('[data-review-avatar]');
        if (avatarNote && avatarNote.files && avatarNote.files[0]) {
          lines.push('', 'Note: Customer attached a profile photo. Add manually when approving.');
        }

        bodyField.value = lines.join('\n');
      });
    });
  }

  initReviewForms();

  function initFilePreview(input, preview, fileNameEl, previewClass) {
    if (!input) return;

    input.addEventListener('change', function () {
      var file = input.files && input.files[0];
      if (fileNameEl) {
        if (file) {
          fileNameEl.textContent = file.name;
          fileNameEl.hidden = false;
        } else {
          fileNameEl.textContent = '';
          fileNameEl.hidden = true;
        }
      }
      if (!preview) return;
      preview.innerHTML = '';
      preview.hidden = true;
      if (!file) return;
      var img = document.createElement('img');
      img.src = URL.createObjectURL(file);
      img.alt = 'Preview';
      img.className = previewClass || 'review-card__photo-preview img--blend';
      preview.appendChild(img);
      preview.hidden = false;
    });
  }

  document.querySelectorAll('[data-review-photo]').forEach(function (input) {
    var form = input.closest('form');
    if (!form) return;
    initFilePreview(
      input,
      form.querySelector('[data-photo-preview]'),
      form.querySelector('[data-file-name]'),
      'review-card__photo-preview img--blend'
    );
  });

  document.querySelectorAll('[data-review-avatar]').forEach(function (input) {
    var form = input.closest('form');
    if (!form) return;
    initFilePreview(
      input,
      form.querySelector('[data-avatar-preview]'),
      form.querySelector('[data-avatar-file-name]'),
      'product-reviews__avatar-preview-img img--blend'
    );
  });

  function initReviewModal() {
    var modal = document.querySelector('[data-review-modal]');
    if (!modal) return;

    var panel = modal.querySelector('.review-modal__panel');
    var openers = document.querySelectorAll('[data-review-modal-open]');
    var closers = modal.querySelectorAll('[data-review-modal-close]');
    var lastFocus = null;

    function openModal() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-review-modal-open');
      requestAnimationFrame(function () {
        modal.classList.add('is-active');
      });
      var firstInput = modal.querySelector('input:not([type="hidden"]), textarea, button');
      if (firstInput) firstInput.focus();
    }

    function closeModal() {
      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-review-modal-open');
      setTimeout(function () {
        modal.hidden = true;
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }, 280);
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', openModal);
    });

    closers.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    if (panel) {
      panel.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }
  }

  initReviewModal();

  var reviewScript = document.querySelector('script[src*="product-reviews.js"]');
  var showMoreLabel = (reviewScript && reviewScript.getAttribute('data-show-more')) || 'Visa mer';
  var showLessLabel = (reviewScript && reviewScript.getAttribute('data-show-less')) || 'Visa mindre';

  document.querySelectorAll('[data-review-body-wrap]').forEach(function (wrap) {
    var body = wrap.querySelector('[data-review-body]');
    var btn = wrap.querySelector('[data-show-more]');
    if (!body || !btn) return;

    requestAnimationFrame(function () {
      var lineHeight = parseFloat(getComputedStyle(body).lineHeight) || 24;
      var maxHeight = lineHeight * 2 + 2;
      if (body.scrollHeight > maxHeight) {
        body.classList.add('is-clamped');
        btn.hidden = false;
      }
    });

    btn.addEventListener('click', function () {
      var expanded = body.classList.toggle('is-expanded');
      body.classList.toggle('is-clamped', !expanded);
      btn.textContent = expanded
        ? btn.getAttribute('data-less-text') || showLessLabel
        : btn.getAttribute('data-more-text') || showMoreLabel;
    });

    btn.setAttribute('data-more-text', showMoreLabel);
    btn.setAttribute('data-less-text', showLessLabel);
    if (!btn.textContent) btn.textContent = showMoreLabel;
  });

  function getStoredLikeCount(id, baseLikes) {
    var key = 'review-like-' + id;
    var stored = parseInt(localStorage.getItem(key), 10);
    if (!isNaN(stored)) return stored;
    return baseLikes;
  }

  function getReviewLikes(item) {
    var id = item.getAttribute('data-review-id') || '';
    var base = parseInt(item.getAttribute('data-review-likes'), 10) || 0;
    return getStoredLikeCount(id, base);
  }

  function getReviewRating(item) {
    return parseInt(item.getAttribute('data-review-rating'), 10) || 0;
  }

  function getReviewTimestamp(item) {
    var iso = item.getAttribute('data-review-date');
    if (iso) {
      var normalized = iso.trim();
      if (/^\d{4}-\d{2}-\d{2}$/.test(normalized)) {
        normalized += 'T12:00:00';
      }
      var parsed = Date.parse(normalized);
      if (!isNaN(parsed)) return parsed;
    }

    var ts = parseInt(item.getAttribute('data-review-timestamp'), 10);
    if (!isNaN(ts) && ts > 0) return ts * 1000;

    return 0;
  }

  function getRelevanceWeight(listEl) {
    if (!listEl) return RELEVANCE_WEIGHT_DEFAULT;
    var w = parseFloat(listEl.getAttribute('data-review-weight'), 10);
    if (isNaN(w) || w < 1) return RELEVANCE_WEIGHT_DEFAULT;
    return w;
  }

  function getAverageRating(items) {
    var jsonEl = document.getElementById('ProductReviewStats');
    if (jsonEl) {
      try {
        var data = JSON.parse(jsonEl.textContent);
        if (data.average != null) {
          var avg = parseFloat(data.average, 10);
          if (!isNaN(avg)) return avg;
        }
        if (data.averageTenths != null) {
          return parseInt(data.averageTenths, 10) / 10;
        }
      } catch (e) {
        /* fall through */
      }
    }

    if (!items.length) return 3;

    var sum = 0;
    items.forEach(function (item) {
      sum += getReviewRating(item);
    });
    return sum / items.length;
  }

  function relevanceScore(item, averageRating, weight) {
    var U = getReviewLikes(item);
    var R = getReviewRating(item);
    var W = weight;
    var C = averageRating;
    var denom = U + W;

    if (denom <= 0) return C;

    return (U / denom) * R + (W / denom) * C;
  }

  function sortReviews(list, mode) {
    var items = Array.prototype.slice.call(list.querySelectorAll('.product-reviews__item'));
    if (!items.length) return items;

    var weight = getRelevanceWeight(list);
    var averageRating = getAverageRating(items);

    items.sort(function (a, b) {
      switch (mode) {
        case 'rating_high':
          return getReviewRating(b) - getReviewRating(a) || getReviewLikes(b) - getReviewLikes(a);
        case 'rating_low':
          return getReviewRating(a) - getReviewRating(b) || getReviewLikes(b) - getReviewLikes(a);
        case 'likes':
          return getReviewLikes(b) - getReviewLikes(a) || getReviewRating(b) - getReviewRating(a);
        case 'date':
          return getReviewTimestamp(b) - getReviewTimestamp(a);
        case 'relevance':
        default:
          return relevanceScore(b, averageRating, weight) - relevanceScore(a, averageRating, weight);
      }
    });

    items.forEach(function (item) {
      list.appendChild(item);
    });

    return items;
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function animateSortedReviews(items) {
    if (!items.length) return;

    if (prefersReducedMotion()) {
      items.forEach(function (item) {
        item.classList.remove('is-sort-animating', 'is-sort-visible');
      });
      return;
    }

    items.forEach(function (item) {
      item.classList.add('is-sort-animating');
      item.classList.remove('is-sort-visible');
    });

    requestAnimationFrame(function () {
      items.forEach(function (item, index) {
        setTimeout(function () {
          item.classList.add('is-sort-visible');
        }, 40 + index * SORT_STAGGER_MS);
      });
    });
  }

  function applySort(list, mode, animate) {
    var items = sortReviews(list, mode);
    if (animate) animateSortedReviews(items);
    return items;
  }

  function getActiveSortMode() {
    var active = document.querySelector('[data-sort-menu] [data-review-sort].is-active');
    return active ? active.getAttribute('data-review-sort') || 'relevance' : 'relevance';
  }

  function initReviewSorting() {
    var list = document.querySelector('[data-reviews-list]');
    var sortWrap = document.querySelector('[data-reviews-sort]');
    var toolbar = document.querySelector('[data-reviews-toolbar]');
    if (!list) return;

    var items = list.querySelectorAll('.product-reviews__item');

    if (items.length > 6 && sortWrap) {
      sortWrap.hidden = false;
      if (toolbar) toolbar.hidden = false;
    }

    applySort(list, 'relevance', false);

    if (!sortWrap) return;

    var trigger = sortWrap.querySelector('[data-sort-trigger]');
    var menu = sortWrap.querySelector('[data-sort-menu]');
    var currentLabel = sortWrap.querySelector('[data-sort-current]');
    var options = sortWrap.querySelectorAll('[data-review-sort]');

    function closeMenu() {
      if (!menu || !trigger) return;
      menu.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }

    function openMenu() {
      if (!menu || !trigger) return;
      menu.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }

    if (trigger) {
      trigger.addEventListener('click', function () {
        if (menu.hidden) openMenu();
        else closeMenu();
      });
    }

    document.addEventListener('click', function (e) {
      if (!sortWrap.contains(e.target)) closeMenu();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });

    options.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mode = btn.getAttribute('data-review-sort') || 'relevance';
        var label = btn.getAttribute('data-sort-label') || btn.textContent.trim();

        options.forEach(function (option) {
          var isActive = option === btn;
          option.classList.toggle('is-active', isActive);
          option.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        if (currentLabel) currentLabel.textContent = label;
        closeMenu();

        var currentItems = list.querySelectorAll('.product-reviews__item');
        currentItems.forEach(function (item) {
          item.classList.remove('is-sort-visible');
          item.classList.add('is-sort-animating');
        });

        requestAnimationFrame(function () {
          applySort(list, mode, true);
        });
      });
    });
  }

  initReviewSorting();

  document.querySelectorAll('[data-like-review]').forEach(function (btn) {
    var id = btn.getAttribute('data-review-id');
    var base = parseInt(btn.getAttribute('data-likes'), 10) || 0;
    var key = 'review-like-' + id;
    var votedKey = key + '-voted';
    var count = getStoredLikeCount(id, base);

    var countEl = btn.querySelector('[data-like-count]');
    if (countEl) countEl.textContent = count;

    if (localStorage.getItem(votedKey) === '1') btn.classList.add('is-liked');

    btn.addEventListener('click', function () {
      var voted = localStorage.getItem(votedKey) === '1';

      if (voted) {
        count = Math.max(base, count - 1);
        localStorage.removeItem(votedKey);
        localStorage.setItem(key, String(count));
        btn.classList.remove('is-liked');
      } else {
        count += 1;
        localStorage.setItem(key, String(count));
        localStorage.setItem(votedKey, '1');
        btn.classList.add('is-liked');
      }

      if (countEl) countEl.textContent = count;

      var list = document.querySelector('[data-reviews-list]');
      if (list) {
        applySort(list, getActiveSortMode(), false);
      }
    });
  });
})();
